import useMailMergeFunctions from 'components/Dashboard/Influence/CrmEmails/MailMergeSection/useMailMergeFunctions';
import { useEmailState } from 'components/EmailStateProvider';
import { useState } from 'react';

const RecipientsActionsMenu = ({
  selectedContacts,
  hasMailMergeData,
  setIsViewModalOpen,
  setIsRemoveMailMergeDataModalOpen,
  setShowActions,
  setIsRemoveRecipientsModalOpen,
}) => {
  const { setEmailState } = useEmailState();

  const [isSavingEmailOnMailMerge, setIsSavingEmailOnMailMerge] = useState(false);
  const { autoSaveEmailOnMailMerge } = useMailMergeFunctions();

  const handleOpenUseMailMerge = () => {
    autoSaveEmailOnMailMerge({
      action: 'UseMailMerge',
      setIsLoading: setIsSavingEmailOnMailMerge,
      callback: () => {
        setEmailState('mailMergeModalIsOpen', true);
        setIsSavingEmailOnMailMerge(false);
        setShowActions(false);
      },
    });
  };

  return (
    <div className='box box-shadow crm-actions-box specific-top-padding-6 specific-bottom-padding-6'>
      <div className='share-container position-relative'>
        <div className='share-container-items flex-column'>
          <button
            onClick={handleOpenUseMailMerge}
            className={`general-button specific-right-padding-35 specific-left-padding-26 specific-top-padding-5 d-flex align-items-center  ${
              selectedContacts === 0 ? 'opacity-5' : ''
            } list-action-button `}
            data-tooltip-content={selectedContacts === 0 ? 'Please add recipients first' : undefined}
            data-tooltip-id={'general-tooltip'}
            data-tooltip-place={'top'}
            data-tooltip-class-name={'general-tooltip pricing-feature-tooltip report-popup-tooltip'}
            disabled={selectedContacts === 0}
          >
            <div className={`${!isSavingEmailOnMailMerge ? 'checkbox-item' : ''} my-0`} style={{ width: '142px' }}>
              {isSavingEmailOnMailMerge ? (
                <i className='fas fa-spinner fa-spin d-inline-block-centered specific-right-margin-2' />
              ) : (
                <input id={`use-mail-merge`} type={'checkbox'} checked={hasMailMergeData} readOnly />
              )}

              <label htmlFor={`use-mail-merge`} className='pl-3'>
                <span className={`${isSavingEmailOnMailMerge ? 'specific-top-padding-2 d-inline-block' : ''}`}>
                  Use mail merge
                </span>
              </label>
            </div>
          </button>
          {selectedContacts >= 1 && (
            <>
              <button
                onClick={() => {
                  setIsViewModalOpen(true);
                  setShowActions(false);
                }}
                className='general-button specific-right-padding-35 specific-left-padding-27 d-flex align-items-center list-action-button'
                disabled={!hasMailMergeData}
              >
                <span className='icon-associated-content' />{' '}
                <span className='specific-left-padding-17'>Review mail merge data</span>
              </button>
              <button
                onClick={(e) => {
                  setIsRemoveMailMergeDataModalOpen(true);
                  setShowActions(false);
                }}
                className='general-button specific-right-padding-35 specific-left-padding-24 d-flex align-items-center list-action-button'
                disabled={!hasMailMergeData}
              >
                <span className='icon-minus-rounded title-h2' />{' '}
                <span className='specific-left-padding-13'>Remove mail merge data</span>
              </button>
              <button
                onClick={(e) => {
                  setIsRemoveRecipientsModalOpen(true);
                  setShowActions(false);
                }}
                disabled={selectedContacts === 0}
                className='general-button specific-right-padding-35 specific-left-padding-16 specific-top-padding-13 specific-bottom-padding-13 border-top d-flex align-items-center list-action-button specific-top-margin-6'
              >
                <span className='icon-remove-stakeholders text-dark-red' />{' '}
                <span className='specific-left-padding-14 text-dark-red'>Remove all recipients</span>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecipientsActionsMenu;
